export enum Placement {
  front = 1,
  main = 0,
  back = -1,
}
